import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import { useTranslation } from "react-i18next";
import useMainContentDimensions from "../../../utils/mainContentDimensions";

import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  CardContent,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import AdvanceFilter from "../../invoices/paid_invoices/components/AdvanceFilter";
import useCancelledInvoices from "../../../hooks/useCancelledInvoice";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function CancelledInvoices(props) {
  let [searchParams, setSearchParams] = useSearchParams();
  const { width: mainContentWidth } = useMainContentDimensions();

  const userId = searchParams.get("id");

  console.log(userId, "i am here");

  const { state } = useLocation();
  const { t } = useTranslation();

  const currentPayload = {
    filters: [
      {
        fieldName: "radUserId",
        fieldValue: userId,
        op: "eq",
        dataType: "int",
        condition: "and",
        isJoin: true,
        attributeName: "radUser",
        entityName: "RadUserEntity",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();
  const {
    getAllCancelledInvoice,
    cancelledInvoices,
    paging,
    downloadFile,
    isLoadingDownload,
    downloadFileType,
  } = useCancelledInvoices();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState(currentPayload);

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const fetchData = async () => {
    await getAllCancelledInvoice(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
  };

  const onPageChange = (page) => {
    console.log(page, "pagepage");
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Invoices</Typography>
        <Typography>Cancelled</Typography>
      </Breadcrumbs>
    );
  };

  useEffect(() => {
    console.log(payload, "payloadpayload");
    fetchData();
  }, [payload, userId]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const columns = [
    {
      field: "invoiceNo",
      headerName: "Invoice No",
      width: 300,
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 300,
    },
    {
      field: "mobileNo",
      headerName: "Mobile No",
      width: 300,
    },
    {
      field: "address",
      headerName: "Address",
      width: 300,
    },
    {
      field: "renewDate",
      headerName: "Invoice Date",
      width: 300,
    },
    {
      field: "finalInvoiceAmount",
      headerName: "Invoice Amount",
      width: 300,
    },
    {
      field: "paidAmount",
      headerName: "Paid Amount",
      width: 300,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardHeader
        action={
          <Toolbar
            downloadFile={(type) => downloadFile(type, payload)}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
          />
        }
        title={t("cancelled_invoices")}
        // subheader={breadCrump()}
      />

      <CardContent sx={{ height: height - 180 }}>
        <DataGrid
          columns={columns}
          rows={cancelledInvoices}
          refreshPage={fetchData}
          getRowId={(row) => row["renewId"]}
          rowCount={paging.totalNumberOfRecords}
          loading={false}
          rowsPerPageOptions={[5]}
          pagination
          page={paging.pageNumber}
          pageSize={paging.pageSize}
          paginationMode="server"
          onPageChange={(page) => onPageChange(page)}
          onPageSizeChange={(pageSize) => onPageChange(pageSize)}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
          }
          sx={{
            "& .MuiDataGrid-row.even-row": {
              backgroundColor: "#f9f9f9", // Light gray for even rows
            },
            "& .MuiDataGrid-row.odd-row": {
              backgroundColor: "#ffffff", // White for odd rows
            },
          }}
        />
      </CardContent>
    </Card>
  );
}

export default CancelledInvoices;
